// ============================================
// Creator Events - Hashtags
// 해시태그 이벤트 핸들러
// ============================================

import {
  initHashtags,
  addHashtag,
  removeHashtag,
  searchTags,
  hideSuggestions,
  navigateSuggestions,
  selectCurrentSuggestion
} from '../editor/hashtags.js';

// ============================================
// 이벤트 초기화
// ============================================

export function initHashtagEvents() {
  // 해시태그 입력 이벤트
  const hashtagInput = document.getElementById('hashtagInput');
  if (hashtagInput) {
    hashtagInput.addEventListener('input', handleHashtagInput);
    hashtagInput.addEventListener('keydown', handleHashtagKeydown);
    hashtagInput.addEventListener('blur', handleHashtagBlur);
    hashtagInput.addEventListener('focus', handleHashtagFocus);
  }

  // 해시태그 영역 클릭 이벤트 위임
  const wrapper = document.querySelector('.hashtag-input-wrapper');
  if (wrapper) {
    wrapper.addEventListener('click', handleHashtagWrapperClick);
  }

  // 외부 클릭 시 드롭다운 닫기
  document.addEventListener('click', handleDocumentClick);

  // 초기화
  initHashtags();
}

// ============================================
// 핸들러
// ============================================

/**
 * 입력 이벤트 - 검색 트리거
 */
function handleHashtagInput(e) {
  const query = e.target.value;
  searchTags(query);
}

/**
 * 키보드 이벤트
 */
function handleHashtagKeydown(e) {
  switch (e.key) {
    case 'Enter':
      e.preventDefault();
      const input = e.target;
      const value = input.value.trim();

      // 드롭다운에서 선택
      if (selectCurrentSuggestion()) {
        input.value = '';
        return;
      }

      // 직접 입력
      if (value && addHashtag(value)) {
        input.value = '';
      }
      break;

    case 'ArrowDown':
      e.preventDefault();
      navigateSuggestions('down');
      break;

    case 'ArrowUp':
      e.preventDefault();
      navigateSuggestions('up');
      break;

    case 'Escape':
      hideSuggestions();
      break;
  }
}

/**
 * blur 이벤트 - 드롭다운 닫기 (약간의 딜레이로 클릭 처리 허용)
 */
function handleHashtagBlur() {
  setTimeout(() => {
    hideSuggestions();
  }, 200);
}

/**
 * focus 이벤트 - 입력값 있으면 검색 재시작
 */
function handleHashtagFocus(e) {
  const value = e.target.value.trim();
  if (value) {
    searchTags(value);
  }
}

/**
 * 래퍼 클릭 이벤트 (이벤트 위임)
 */
function handleHashtagWrapperClick(e) {
  // 추가 버튼 클릭
  const addBtn = e.target.closest('[data-action="addHashtag"]');
  if (addBtn) {
    const input = document.getElementById('hashtagInput');
    if (input && input.value.trim()) {
      if (addHashtag(input.value.trim())) {
        input.value = '';
        input.focus();
      }
    }
    return;
  }

  // 태그 제거 버튼 클릭
  const removeBtn = e.target.closest('[data-action="removeHashtag"]');
  if (removeBtn) {
    const index = parseInt(removeBtn.dataset.index);
    if (!isNaN(index)) {
      removeHashtag(index);
    }
    return;
  }

  // 자동완성 항목 클릭
  const suggestionItem = e.target.closest('.suggestion-item');
  if (suggestionItem && suggestionItem.dataset.tag) {
    const input = document.getElementById('hashtagInput');
    if (addHashtag(suggestionItem.dataset.tag)) {
      if (input) {
        input.value = '';
        input.focus();
      }
    }
    return;
  }
}

/**
 * 문서 클릭 - 외부 클릭 시 드롭다운 닫기
 */
function handleDocumentClick(e) {
  const wrapper = document.querySelector('.hashtag-input-wrapper');
  if (wrapper && !wrapper.contains(e.target)) {
    hideSuggestions();
  }
}
